/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
import React from 'react';
import { CDN } from '../../../../constants';

function ApprovedOrdersDistributorDetails({ OrderDetails, handleSuccessMessage }) {
    const handleImage = (img) => (img !== undefined ? `${CDN}/${img}` : '/images/profile_picture_user_icon_153847.png');

    return (
        <div className="border border-[#CBC7C7 rounded-md bg-[#F5F5FA] h-auto p-4">
            <h5 className="text-xs2 font-semibold text-[#000000]">Distributor/Customer Details</h5>
            <div className="mt-3 flex items-center">
                <div>

                    <img src={handleImage(OrderDetails.distributor_info?.profile_image_url)} alt="icon" loading="lazy" decoding="async" style={{ borderRadius: '50%', height: '55px', width: '55px' }} />

                </div>
                <div className="pl-3.5">
                    {(OrderDetails.distributor_info.FIRST_NAME !== null || OrderDetails.distributor_info.LAST_NAME !== null)
                        ? (
                            <p className="text-base font-semibold text-[#303030]">
                                {OrderDetails.distributor_info.FIRST_NAME}
                                {' '}
                                {OrderDetails.distributor_info.LAST_NAME}
                            </p>
                        )
                        : (
                            <p className="text-base font-semibold text-[#303030]">
                                {OrderDetails.distributor_info.PARTY_NAME}

                            </p>
                        )}

                    <p className="text-xs13 font-normal text-[#555259]">{OrderDetails.distributor_id}</p>
                </div>
            </div>
            <div className="flex -mx-0.5 mt-2.5">
                <div className="w-1/2 px-0.5">
                    <p className="text-xs3 font-semibold text-[#808285]">Mobile Number</p>
                    {OrderDetails.distributor_info.PRIMARY_PHONE_NUMBER !== ' '
                        ? <p className="pt-1 text-sm font-normal text-[#090406]">{OrderDetails.distributor_info.PRIMARY_PHONE_NUMBER}</p>
                        : <p className="pt-1 text-sm font-normal text-[#090406]">-</p> }
                </div>
                <div className="w-1/2 px-0.5">
                    <p className="text-xs3 font-semibold text-[#808285]">Email Address</p>
                    {OrderDetails.distributor_info.EMAIL_ADDRESS !== null
                        ? <p className="pt-1 text-sm font-normal text-[#090406] break-words">{OrderDetails.distributor_info.EMAIL_ADDRESS}</p>
                        : <p className="pt-1 text-sm font-normal text-[#090406] break-words">-</p>}
                </div>
            </div>
            <p className="font-bold text-xs2 text-[#000000] mt-6">Company Details</p>
            <div className="w-3/5 px-0.5 mt-5">
                <p className="text-xs3 font-semibold text-[#808285]">Company Name</p>
                <p className="pt-1 text-sm font-normal text-[#090406] break-words" data-testid="company-name">{OrderDetails.distributor_company_name}</p>
            </div>
            <div className="w-1/2 px-0.5 mt-3">
                <p className="text-xs3 font-semibold text-[#808285]">Mobile Number</p>
                {(OrderDetails.distributor_info.SECONDARY_PHONE_NUMBER !== null || OrderDetails.distributor_info.SECONDARY_PHONE_NUMBER !== null)
                    ? <p className="pt-1 text-sm font-normal text-[#090406]">{OrderDetails.distributor_info.SECONDARY_PHONE_NUMBER}</p>
                    : <p className="pt-1 text-sm font-normal text-[#090406]">-</p> }
            </div>
            <div className="w-1/2 px-0.5 mt-3">
                <p className="text-xs3 font-semibold text-[#808285]">Email Address</p>
                {OrderDetails.distributor_info.EMAIL_ADDRESS !== null
                    ? <p className="pt-1 text-sm font-normal text-[#090406] break-words">{OrderDetails.distributor_info.EMAIL_ADDRESS}</p>
                    : <p className="pt-1 text-sm font-normal text-[#090406] break-words">-</p>}
            </div>
            <div className="flex -mx-0.5 mt-3">
                <div className="w-1/2 px-0.5">
                    <p className="text-xs3 font-semibold text-[#808285]">GSTIN</p>
                    <p className="pt-1 text-sm font-normal text-[#090406]">{OrderDetails.distributor_info.GSTIN}</p>
                </div>
                <div className="w-1/2 px-0.5">
                    <p className="text-xs3 font-semibold text-[#808285]">PAN Number</p>
                    <p className="pt-1 text-sm font-normal text-[#090406] break-words">{OrderDetails.distributor_info.PAN_NUMBER}</p>
                </div>
            </div>
        </div>
    );
}

export default ApprovedOrdersDistributorDetails;
